import type { FunctionCallingConfigFormToolField } from "components/formControls/FunctionCallingConfigControl/types";
import type { Tool } from "../types";

export const transformToolToFunctionCallFormField = (
  tool: Tool,
): FunctionCallingConfigFormToolField => {
  return {
    description: tool.description,
    entityId: tool.entityId,
    entityType: tool.entityType,
    id: tool.id,
    isApprovalRequired: tool.isApprovalRequired,
  };
};
